import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent, ImageTransform } from 'ngx-image-cropper';

export type AspectRatioMode = 'free' | '1:1' | '4:3' | '16:9';

@Component({
  selector: 'app-image-cropper-modal',
  templateUrl: './image-cropper-modal.component.html',
  styleUrls: ['./image-cropper-modal.component.scss'],
})
export class ImageCropperModalComponent implements OnInit {
  @ViewChild(ImageCropperComponent) cropperComponent?: ImageCropperComponent;

  @Input() title = 'Recortar Logotipo';
  @Input() imageFile: File | undefined = undefined;
  @Input() aspectRatio = 1;
  @Input() maintainAspectRatio = false;
  @Input() containWithinAspectRatio = true;
  @Input() defaultAspectMode: AspectRatioMode = 'free';

  @Output() cropped = new EventEmitter<Blob>();
  @Output() close = new EventEmitter<void>();

  croppedEvent: ImageCroppedEvent | null = null;
  loading = true;

  aspectMode: AspectRatioMode = 'free';

  canvasRotation = 0;
  scale = 1;
  transform: ImageTransform = {};

  ngOnInit(): void {
    if (this.maintainAspectRatio && this.defaultAspectMode === 'free') {
      this.aspectMode = '1:1';
      this.aspectRatio = 1;
    } else {
      this.aspectMode = this.defaultAspectMode;
      this.applyAspectMode(this.aspectMode);
    }
  }

  setAspectMode(mode: AspectRatioMode): void {
    this.aspectMode = mode;
    this.applyAspectMode(mode);
    setTimeout(() => {
      this.cropperComponent?.resetCropperPosition();
    }, 50);
  }

  private applyAspectMode(mode: AspectRatioMode): void {
    if (mode === 'free') {
      this.maintainAspectRatio = false;
      this.containWithinAspectRatio = false;
    } else {
      this.maintainAspectRatio = true;
      this.containWithinAspectRatio = true;
      if (mode === '1:1') this.aspectRatio = 1;
      else if (mode === '4:3') this.aspectRatio = 4 / 3;
      else if (mode === '16:9') this.aspectRatio = 16 / 9;
    }
  }

  zoomIn(): void {
    this.scale = Math.min(this.scale + 0.15, 3);
    this.updateTransform();
  }

  zoomOut(): void {
    this.scale = Math.max(this.scale - 0.15, 0.4);
    this.updateTransform();
  }

  rotateLeft(): void {
    this.canvasRotation--;
  }

  rotateRight(): void {
    this.canvasRotation++;
  }

  resetAll(): void {
    this.scale = 1;
    this.canvasRotation = 0;
    this.transform = {};
    this.setAspectMode('free');
  }

  private updateTransform(): void {
    this.transform = {
      ...this.transform,
      scale: this.scale,
    };
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedEvent = event;
  }

  imageLoaded(): void {
    this.loading = false;
  }

  cropperReady(): void {
    this.loading = false;
  }

  loadImageFailed(): void {
    this.loading = false;
    console.error('Falha ao carregar imagem para recorte.');
  }

  onCancel(): void {
    this.close.emit();
  }

  onConfirm(): void {
    if (this.croppedEvent && this.croppedEvent.blob) {
      this.cropped.emit(this.croppedEvent.blob);
    } else {
      this.close.emit();
    }
  }
}
